import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "toolbar" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_8 = { class: "table table-striped table-hover" }
const _hoisted_9 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_10 = {
  key: 2,
  class: "text-center text-muted py-5"
}
const _hoisted_11 = {
  key: 3,
  class: "table-responsive"
}
const _hoisted_12 = {
  class: "table table-striped table-hover table-sm",
  "data-testid": "user-table"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "d-flex align-items-center gap-1" }
const _hoisted_15 = {
  key: 0,
  class: "fas fa-sort-up"
}
const _hoisted_16 = {
  key: 1,
  class: "fas fa-sort-down"
}
const _hoisted_17 = {
  key: 2,
  class: "fas fa-sort text-muted"
}
const _hoisted_18 = {
  key: 0,
  class: "expanded-row"
}
const _hoisted_19 = ["colspan"]
const _hoisted_20 = { class: "pagination-bar" }
const _hoisted_21 = { class: "d-flex align-items-center gap-2" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "d-flex align-items-center gap-2" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  class: "small",
  "data-testid": "page-indicator"
}
const _hoisted_26 = ["disabled"]

import { ref, computed } from "vue";
import { FlexRender } from "@tanstack/vue-table";
import { useUserTable } from "../composables/useUserTable.js";
import UserDetailExpanded from "./UserDetailExpanded.vue";


export default {
  __name: 'UserTable',
  props: {
	users: { type: Array, default: () => [] },
	roles: { type: Array, default: () => [] },
	loading: { type: Boolean, default: false },
	error: { type: String, default: "" },
	isRefreshing: { type: Function, required: true },
},
  emits: ["refresh", "edit", "deleted"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const { table, globalFilter, columnFilters, pagination } = useUserTable(() => props.users, {
	onRefresh: (id) => emit("refresh", id),
	onEdit: (user) => emit("edit", user),
	isRefreshing: (id) => props.isRefreshing(id),
});

const columnFilterValue = (columnId) => columnFilters.value.find((filter) => filter.id === columnId)?.value ?? "";
const typeFilter = computed(() => columnFilterValue("type"));
const roleFilter = computed(() => columnFilterValue("roles"));
const hasActiveFilters = computed(() => Boolean(globalFilter.value) || columnFilters.value.length > 0);

const resetFilters = () => {
	table.resetGlobalFilter();
	table.resetColumnFilters();
};

const searchInputRef = ref(null);
const focusSearch = () => searchInputRef.value?.focus();

__expose({ table, focusSearch });

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("input", {
        ref_key: "searchInputRef",
        ref: searchInputRef,
        class: "form-control toolbar-search",
        type: "search",
        placeholder: "Suchen...",
        value: _unref(globalFilter),
        "data-testid": "user-search",
        onInput: _cache[0] || (_cache[0] = $event => (_unref(table).setGlobalFilter($event.target.value)))
      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2),
      _createElementVNode("select", {
        class: "form-select",
        "data-testid": "user-type-filter",
        value: typeFilter.value,
        onChange: _cache[1] || (_cache[1] = $event => (_unref(table).getColumn('type').setFilterValue($event.target.value || undefined)))
      }, [...(_cache[6] || (_cache[6] = [
        _createElementVNode("option", { value: "" }, " Alle Typen ", -1 /* CACHED */),
        _createElementVNode("option", { value: "LDAP" }, " LDAP ", -1 /* CACHED */),
        _createElementVNode("option", { value: "Lokal" }, " Lokal ", -1 /* CACHED */)
      ]))], 40 /* PROPS, NEED_HYDRATION */, _hoisted_3),
      _createElementVNode("select", {
        class: "form-select",
        "data-testid": "user-role-filter",
        value: roleFilter.value,
        onChange: _cache[2] || (_cache[2] = $event => (_unref(table).getColumn('roles').setFilterValue($event.target.value || undefined)))
      }, [
        _cache[7] || (_cache[7] = _createElementVNode("option", { value: "" }, " Alle Rollen ", -1 /* CACHED */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.roles, (role) => {
          return (_openBlock(), _createElementBlock("option", {
            key: role.id,
            value: role.id
          }, _toDisplayString(role.title), 9 /* TEXT, PROPS */, _hoisted_5))
        }), 128 /* KEYED_FRAGMENT */))
      ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_4),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline-secondary",
        "data-testid": "reset-filters",
        disabled: !hasActiveFilters.value,
        onClick: resetFilters
      }, [...(_cache[8] || (_cache[8] = [
        _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */),
        _createTextVNode(" Filter zurücksetzen ", -1 /* CACHED */)
      ]))], 8 /* PROPS */, _hoisted_6)
    ]),
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("tbody", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                return _createElementVNode("tr", { key: n }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (col) => {
                    return _createElementVNode("td", { key: col }, [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("div", { class: "skeleton skeleton-row" }, null, -1 /* CACHED */)
                    ]))])
                  }), 64 /* STABLE_FRAGMENT */))
                ])
              }), 64 /* STABLE_FRAGMENT */))
            ])
          ])
        ]))
      : (__props.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(__props.error), 1 /* TEXT */))
        : (_unref(table).getRowModel().rows.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Keine Benutzer*innen gefunden. "))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("table", _hoisted_12, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(table).getFlatHeaders(), (header) => {
                      return (_openBlock(), _createElementBlock("th", {
                        key: header.id,
                        class: _normalizeClass({
                sortable: header.column.getCanSort(),
                'expand-column': header.id === 'expand',
                'actions-column': header.id === 'actions',
              }),
                        onClick: $event => (header.column.getToggleSortingHandler()?.($event))
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_unref(FlexRender), {
                            render: header.column.columnDef.header,
                            props: header.getContext()
                          }, null, 8 /* PROPS */, ["render", "props"]),
                          (header.column.getCanSort() && header.column.getIsSorted() === 'asc')
                            ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                            : (header.column.getCanSort() && header.column.getIsSorted() === 'desc')
                              ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                              : (header.column.getCanSort())
                                ? (_openBlock(), _createElementBlock("i", _hoisted_17))
                                : _createCommentVNode("v-if", true)
                        ])
                      ], 10 /* CLASS, PROPS */, _hoisted_13))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(table).getRowModel().rows, (row) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: row.id
                    }, [
                      _createElementVNode("tr", {
                        class: _normalizeClass(["main-row", { expanded: row.getIsExpanded() }]),
                        "data-testid": "user-row"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.getVisibleCells(), (cell) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: cell.id,
                            class: _normalizeClass({
                  'expand-column': cell.column.id === 'expand',
                  'actions-column': cell.column.id === 'actions',
                })
                          }, [
                            _createVNode(_unref(FlexRender), {
                              render: cell.column.columnDef.cell,
                              props: cell.getContext()
                            }, null, 8 /* PROPS */, ["render", "props"])
                          ], 2 /* CLASS */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 2 /* CLASS */),
                      (row.getIsExpanded())
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                            _createElementVNode("td", {
                              colspan: row.getAllCells().length,
                              class: "p-0"
                            }, [
                              _createVNode(UserDetailExpanded, {
                                user: row.original,
                                onEdit: $event => (_ctx.$emit('edit', row.original)),
                                onDeleted: () => { row.toggleExpanded(false); _ctx.$emit('deleted', row.original); }
                              }, null, 8 /* PROPS */, ["user", "onEdit", "onDeleted"])
                            ], 8 /* PROPS */, _hoisted_19)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label mb-0 small" }, "Einträge pro Seite:", -1 /* CACHED */)),
                  _createElementVNode("select", {
                    class: "form-select form-select-sm",
                    style: {"width":"auto"},
                    value: _unref(pagination).pageSize,
                    onChange: _cache[3] || (_cache[3] = $event => (_unref(table).setPageSize(Number($event.target.value))))
                  }, [...(_cache[10] || (_cache[10] = [
                    _createElementVNode("option", { value: 25 }, " 25 ", -1 /* CACHED */),
                    _createElementVNode("option", { value: 50 }, " 50 ", -1 /* CACHED */),
                    _createElementVNode("option", { value: 100 }, " 100 ", -1 /* CACHED */)
                  ]))], 40 /* PROPS, NEED_HYDRATION */, _hoisted_22)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-outline-secondary",
                    "data-testid": "page-prev",
                    disabled: !_unref(table).getCanPreviousPage(),
                    onClick: _cache[4] || (_cache[4] = $event => (_unref(table).previousPage()))
                  }, [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1 /* CACHED */)
                  ]))], 8 /* PROPS */, _hoisted_24),
                  _createElementVNode("span", _hoisted_25, " Seite " + _toDisplayString(_unref(pagination).pageIndex + 1) + " von " + _toDisplayString(Math.max(_unref(table).getPageCount(), 1)), 1 /* TEXT */),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-outline-secondary",
                    "data-testid": "page-next",
                    disabled: !_unref(table).getCanNextPage(),
                    onClick: _cache[5] || (_cache[5] = $event => (_unref(table).nextPage()))
                  }, [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1 /* CACHED */)
                  ]))], 8 /* PROPS */, _hoisted_26)
                ])
              ])
            ]))
  ]))
}
}

}